import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, failedResponse } from "../common";
import { getToken } from "../../features/user/UserAvatar";

export interface HomeworkCheckChangeState {
    requests: {
        state: LoadStateInfo;
        request: HomeworkCheckChangeRequest
    }[];
}

const initialState: HomeworkCheckChangeState = {
    requests: [],
};
export function findHomeworkCheckRequest(requests: HomeworkCheckChangeState["requests"], payload: HomeworkCheckChangeRequest) {
    return requests.find((r) =>
        r.request.classroomId == payload.classroomId &&
        r.request.studentId == payload.studentId &&
        r.request.homeworkId == payload.homeworkId
    );
}
export interface HomeworkCheckChangeRequest {
    schoolId: number;
    classroomId: number;
    homeworkId: number;
    studentId: string;
    done: number;
}
export const homeworkCheckChange = createAsyncThunk(
    "homeworkCheckChange",
    async (param: HomeworkCheckChangeRequest, thunkAPI) => {
        console.debug(`change homework check for classroom ${param.classroomId}, student ${param.studentId}, homework ${param.homeworkId} to done ${param.done}`);

        const response = await fetch(`${getBackendUrl()}/api/homework-check/change`, {
            method: "POST",
            signal: thunkAPI.signal,
            headers: {
                "Authorization": `Bearer ${getToken()}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(param)
        });

        if (response.ok) {
            return await response.json();
        } else {
            return thunkAPI.rejectWithValue(failedResponse(response));
        }
    },
    // {
    //     condition: (param: RoutineRecordChangeRequest, thunkAPI) => {
    //         const state = thunkAPI.getState() as RootState;
    //         const status = state.routineRecordList;
    //         if (!status || !status.state) {
    //             return true;
    //         }
    //         if (status.state.state == LoadState.NotStarted) {
    //             return true;
    //         }
    //         console.debug(`retrieveRoutineRecordList skipped: ${status.state.state}`);
    //         return false;
    //     }
    // }
);

export const homeworkCheckChangeSlice = createSlice({
    name: "homeworkCheckChangeList",
    initialState,
    reducers: {
        clear: (state, action: PayloadAction<HomeworkCheckChangeRequest>) => {
            const request = findHomeworkCheckRequest(state.requests, action.payload);
            if (request) {
                request.state = notStarted();
                request.request = action.payload;
            } else if (!request) {
                state.requests.push({
                    state: notStarted(),
                    request: action.payload
                });
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(homeworkCheckChange.pending, (state, action) => {
                const payload = action.meta.arg;
                const request = findHomeworkCheckRequest(state.requests, payload);
                if (request) {
                    request.state = loading();
                    request.request = payload;
                } else if (!request) {
                    state.requests.push({
                        state: loading(),
                        request: payload
                    });
                }
            })
            .addCase(homeworkCheckChange.fulfilled, (state, action) => {
                console.debug(`${action.type}`);
                const payload = action.meta.arg;
                const request = findHomeworkCheckRequest(state.requests, payload);
                if (request) {
                    request.state = loaded();
                    request.request = payload;
                }
            })
            .addCase(homeworkCheckChange.rejected, (state, action) => {
                const payload = action.meta.arg;
                const request = findHomeworkCheckRequest(state.requests, payload);
                if (request) {
                    request.state = error(action);
                    request.request = payload;
                }
            });
    },
});

// export const { } = homeworkCheckChangeSlice.actions;

export const selectHomeworkCheckChange = (state: RootState) => state.homeworkCheckChange;

export default homeworkCheckChangeSlice.reducer;
